import type { TFunction } from 'i18next';
import { REGEX_EXAMPLES } from '@/constants/regex-presets';

export const getRegexValidationMessage = (pattern: string, t: TFunction) => {
  const preset = REGEX_EXAMPLES.find((example) => example.pattern === pattern);
  if (preset) return t(`newPrintPage.validation.regexExamples.${preset.key}`);
  return t('newPrintPage.validation.customRegex', { pattern });
};
